/**
 * Page layout components for consistent page structure
 * Handles scrolling, safe areas, and common layouts
 * Theme-aware styling (light/dark)
 */

/**
 * Standard scrollable page layout
 * Use this for most pages that need to scroll
 */
export function PageLayout({ children, className = '' }) {
  return (
    <div className={`page-layout ${className}`}>
      {children}
    </div>
  )
}

/**
 * Fixed layout for full-screen pages like chat
 * Content doesn't scroll - use internal scroll containers
 */
export function FixedLayout({ children, className = '' }) {
  return (
    <div className={`fixed-layout ${className}`}>
      {children}
    </div>
  )
}

/**
 * Page content wrapper with consistent padding
 */
export function PageContent({ children, className = '', noPadding = false }) {
  return (
    <div className={`${noPadding ? '' : 'px-4 py-4'} ${className}`}>
      {children}
    </div>
  )
}

/**
 * Page section with consistent spacing
 */
export function PageSection({ children, title, action, className = '' }) {
  return (
    <section className={`mb-6 ${className}`}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-3 px-1">
          {title && (
            <h2 className="text-sm font-medium text-gray-500 dark:text-indices-muted font-display">{title}</h2>
          )}
          {action}
        </div>
      )}
      {children}
    </section>
  )
}

export default {
  PageLayout,
  FixedLayout,
  PageContent,
  PageSection,
}
